import { doc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

// 우선순위: (0) 사용자 본인 설정값  >  (1) 본사 디폴트  >  하드코딩 폴백
// - realtors/{uid}.invite_message_template  (본인)
// - settings/invite_message.default         (본사)

const FALLBACK_TEMPLATE =
  '안녕하세요 "{orgName}" 입니다.\n이사를 준비하시면서 필요한 서비스를 한번에 신청하세요.\n\n[무료 견적 신청하기]\n{formUrl}';

export const renderTemplate = (tmpl, { orgName, formUrl }) =>
  (tmpl || FALLBACK_TEMPLATE)
    .replaceAll('{orgName}', orgName || '부동산')
    .replaceAll('{formUrl}', formUrl || '');

export const getHqDefaultTemplate = async () => {
  try {
    const snap = await getDoc(doc(db, 'settings', 'invite_message'));
    if (snap.exists()) return snap.data().default || '';
  } catch (_) {}
  return '';
};

export const getRealtorTemplate = async (uid) => {
  if (!uid) return '';
  try {
    const snap = await getDoc(doc(db, 'realtors', uid));
    if (snap.exists()) return snap.data().invite_message_template || '';
  } catch (_) {}
  return '';
};

// 최종 문구를 렌더해서 반환 (본인 > 본사 > 폴백)
export const resolveInviteMessage = async (uid, { orgName, formUrl }) => {
  const mine = await getRealtorTemplate(uid);
  if (mine) return renderTemplate(mine, { orgName, formUrl });
  const hq = await getHqDefaultTemplate();
  if (hq) return renderTemplate(hq, { orgName, formUrl });
  return renderTemplate(FALLBACK_TEMPLATE, { orgName, formUrl });
};

export const saveRealtorTemplate = async (uid, template) => {
  if (!uid) return;
  // 저장 시에는 placeholder 형태를 유지하기 위해 orgName/formUrl 은 그대로 두고
  // 실제 값이 들어간 경우라도 치환하지 않는다 (호출측이 편집 원문을 넘기도록)
  await updateDoc(doc(db, 'realtors', uid), {
    invite_message_template: template,
    updatedAt: serverTimestamp(),
  });
};

export { FALLBACK_TEMPLATE };
